














import {
  Component, Vue, Prop,
} from 'vue-property-decorator';
import { ClientInfoDTO } from '@/api';

@Component({
  name: 'shopping-client-object',
})
export default class CatalogFilter extends Vue {
  @Prop(Object) client!: ClientInfoDTO;
}
